export default __webpack_public_path__ + "static/test_2_3-18e889945cf97ed8faecb01de82b389c.png";